import React from "react";
import { useTranslation } from "react-i18next";
import { Mail, Phone } from "lucide-react";
import BrandLogo from "./BrandLogo";

const NAV_ITEMS = [
  { id: "metoden", key: "nav.metoden" },
  { id: "biologi", key: "nav.biologi" },
  { id: "banen", key: "nav.banen" },
  { id: "coach", key: "nav.coach" },
  { id: "historien", key: "nav.historien" },
  { id: "udtalelser", key: "nav.udtalelser" },
  { id: "videnskab", key: "nav.videnskab" },
  { id: "kontakt", key: "nav.kontakt" },
];

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden border-t border-white/5 bg-[#05020E]"
    >
      {/* Top neon line */}
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, #FF2D5C 20%, #FF3DCB 40%, #9B4DFF 60%, #3DBFFF 80%, transparent)",
        }}
      />

      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-14">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <BrandLogo
              size="sm"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />
            <p className="mt-4 max-w-md text-sm text-white/60 leading-relaxed">
              {t("footer.tagline")}
            </p>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.24em] text-white/35">
              6 sæsoner · 6 titler — U15 · U17 · U19
            </p>
          </div>

          {/* Links */}
          <div className="lg:col-span-3">
            <span className="eyebrow">{t("footer.links_title")}</span>
            <ul className="mt-5 grid grid-cols-2 gap-2">
              {NAV_ITEMS.map((item) => (
                <li key={item.id}>
                  <button
                    data-testid={`footer-link-${item.id}`}
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-white/65 hover:text-white transition-colors"
                  >
                    {t(item.key)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <span className="eyebrow">{t("footer.contact_title")}</span>
            <div className="mt-5 space-y-3">
              <a
                data-testid="footer-mail"
                href="mailto:ds@elektrouniversal.dk"
                className="link-neon flex items-center gap-3 text-sm"
              >
                <Mail className="h-4 w-4" />
                ds@elektrouniversal.dk
              </a>
              <a
                data-testid="footer-phone"
                href="tel:+4560439162"
                className="link-neon flex items-center gap-3 text-sm"
              >
                <Phone className="h-4 w-4" />
                +45 60 43 91 62
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-6 md:flex-row md:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
            © {year} EleKtro Universal · {t("footer.rights")}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
            Future Football™
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
